import { Link } from "react-router-dom";
import SeoHead from "@/components/SeoHead";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <>
      <SeoHead title="Page introuvable - Dégraissage Hotte Melun" canonicalPath="/404" noIndex />
      <section className="bg-white py-24 md:py-32 text-center">
        <div className="max-w-2xl mx-auto px-4">
          <div className="dh-num text-9xl text-[#00367e]/15 leading-none">404</div>
          <h1 className="mt-6 text-3xl md:text-4xl font-black text-[#00367e]">Page introuvable</h1>
          <p className="mt-4 text-slate-700 text-lg">La page que vous cherchez n'existe pas ou a été déplacée.</p>
          <Link
            to="/"
            data-testid="back-home-btn"
            className="mt-8 inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-[#00367e] hover:bg-[#066ec4] text-white font-bold shadow-xl transition-all"
          >
            <Home size={20} /> Retour à l'accueil
          </Link>
        </div>
      </section>
    </>
  );
}
